import { IonicPage } from 'ionic-angular';
import { Component } from '@angular/core';
import { AppConfig } from '../../../../app/app.config';

@IonicPage()
@Component({
  selector: 'page-safety-edit',
  templateUrl: 'safety-edit.html',
})
export class SafetyEditPage {

  config = AppConfig.settings;

  constructor() {
  }

  ionViewDidLoad() {

  }
}



// WEBPACK FOOTER //
// ./src/pages/DPR Pages/safety/safety-edit/safety-edit.ts